import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import CommonApi from "../../../api/common.api";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import ImgInput from "../../../component/atoms/input/imgInput";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageFormCol from "../../../component/atoms/layout/detail/detailPageFormCol";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import ImgPreview from "../../../component/molecules/imgPreview";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { imgUrl } from "../../../constants/url";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import PretendardText from "../../../component/atoms/text/pretendardText";
import ConsultingApi from "../../../api/consulting.api";

const ConsultingEdit = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // ----- 정보 가져오기
  const [consultingInfo, setConsultingInfo] = useState({
    activation: true,
    alarmFlag: true,
    title: "",
    content: "",
    price: "",
    fileThumbnail: "",
    fileUrlThumbnail: "",
    fileInstructor: "",
    fileUrlInstructor: "",
    instructorName: "",
    instructorIntro: "",
    career: [],
  });

  const [career, setCareer] = useState("");

  useEffect(() => {
    getConsultingInfo();
  }, []);

  const getConsultingInfo = async () => {
    try {
      const response = (await ConsultingApi.getById(id)).data.data.content;
      setConsultingInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const changeCareer = (value, index) => {
    const copyCareer = [...consultingInfo.career];
    copyCareer[index] = value;

    setConsultingInfo({
      ...consultingInfo,
      career: copyCareer,
    });
  };

  const delImg = (type) => {
    if (type === "thumbnail") {
      setConsultingInfo({
        ...consultingInfo,
        fileThumbnail: "",
        fileUrlThumbnail: "",
        thumbnailOriginFileName: "",
        thumbnailServerFileName: "",
      });
    } else {
      setConsultingInfo({
        ...consultingInfo,
        fileInstructor: "",
        fileUrlInstructor: "",
        instructorOriginFileName: "",
        instructorServerFileName: "",
      });
    }
  };

  //이미지 추가, 삭제
  const inputFile = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (value) => {
      if (type === "thumbnail") {
        setConsultingInfo({
          ...consultingInfo,
          fileThumbnail: file,
          fileUrlThumbnail: value.target.result,
        });
      } else {
        setConsultingInfo({
          ...consultingInfo,
          fileInstructor: file,
          fileUrlInstructor: value.target.result,
        });
      }
    };
    e.target.value = "";
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    const plainContent = consultingInfo.content
      ?.replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    if (
      !consultingInfo.title?.trim() ||
      !Number.isFinite(Number(consultingInfo.price)) ||
      Number(consultingInfo.price) < 0 ||
      (!consultingInfo.thumbnailOriginFileName &&
        isNull(consultingInfo.fileThumbnail)) ||
      (!consultingInfo.instructorOriginFileName &&
        isNull(consultingInfo.fileInstructor)) ||
      !plainContent ||
      !consultingInfo.instructorName?.trim() ||
      !consultingInfo.instructorIntro?.trim()
    ) {
      return toast("필수사항을 모두 입력해주세요.");
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        activation: consultingInfo.activation,
        alarmFlag: consultingInfo.alarmFlag,
        title: consultingInfo.title.trim(),
        content: consultingInfo.content,
        price: Number(consultingInfo.price),
        thumbnailOriginFileName: "",
        thumbnailServerFileName: "",
        instructorOriginFileName: "",
        instructorServerFileName: "",
        instructorName: consultingInfo.instructorName.trim(),
        instructorIntro: consultingInfo.instructorIntro.trim(),
        career: consultingInfo.career
          .map((item) => item.trim())
          .filter(Boolean),
      };

      if (!isNull(consultingInfo.fileUrlThumbnail)) {
        const result = await fileUpload(consultingInfo.fileThumbnail);
        data.thumbnailOriginFileName = result.imageOriginFileName;
        data.thumbnailServerFileName = result.imageServerFileName;
      }
      if (!isNull(consultingInfo.fileUrlInstructor)) {
        const result = await fileUpload(consultingInfo.fileInstructor);
        data.instructorOriginFileName = result.imageOriginFileName;
        data.instructorServerFileName = result.imageServerFileName;
      }

      await ConsultingApi.edit(id, data);
      toast(toastMsg.update);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("path", "consulting");
      formData.append("file", file);

      const response = (await CommonApi.fileUpload(formData)).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (error) {
      errorHandler(error);
    }
  };

  // 에디터
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>추가하기</DetailPageTitle>
            <DetailPageTitle>기본 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={true}
                    name={"activation"}
                    valueText={"활성"}
                    checked={consultingInfo.activation}
                    onChange={() => {
                      setConsultingInfo({
                        ...consultingInfo,
                        activation: true,
                      });
                    }}
                  />
                  <Radio
                    id={false}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!consultingInfo.activation}
                    onChange={() => {
                      setConsultingInfo({
                        ...consultingInfo,
                        activation: false,
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>필요서류제출 알림*</DetailFormTitle>
                <CheckboxWrapper>
                  <Checkbox
                    id="alarm"
                    checked={consultingInfo.alarmFlag}
                    onChange={() => {
                      setConsultingInfo({
                        ...consultingInfo,
                        alarmFlag: !consultingInfo.alarmFlag,
                      });
                    }}
                  />
                  <DetailFormText>알림 발송</DetailFormText>
                </CheckboxWrapper>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제 금액*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"결제 금액을 입력해주세요"}
                  value={consultingInfo.price}
                  onChange={(e) =>
                    setConsultingInfo({
                      ...consultingInfo,
                      price: e.target.value,
                    })
                  }
                />
              </DetailPageForm>
            </div>
          </DetailPage>
          <DetailPage>
            <DetailPageTitle>강의 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>컨설팅명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"컨설팅명을 입력해주세요"}
                  value={consultingInfo.title}
                  onChange={(e) =>
                    setConsultingInfo({
                      ...consultingInfo,
                      title: e.target.value,
                    })
                  }
                />
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>썸네일 이미지*</DetailFormTitle>
                {consultingInfo.thumbnailServerFileName ||
                consultingInfo.fileThumbnail ? (
                  <ImgPreview
                    fileUrl={
                      consultingInfo.fileUrlThumbnail
                        ? consultingInfo.fileUrlThumbnail
                        : imgUrl + consultingInfo.thumbnailServerFileName
                    }
                    onClick={() => {
                      delImg("thumbnail");
                    }}
                    style={{ width: "150px", height: "94px" }}
                    imgStyle={{ width: "150px", height: "94px" }}
                  />
                ) : (
                  <ImgInput
                    id={"thumbnail"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e, "thumbnail");
                    }}
                    style={{ width: "150px", height: "94px" }}
                  />
                )}
              </DetailPageForm>
              <DetailPageFormCol>
                <DetailFormTitle>강의 소개*</DetailFormTitle>
                <StyledQuillContainer>
                  <TextFormEditor
                    placeholder={"내용을 입력해 주세요."}
                    value={consultingInfo.content}
                    onChange={(contents) => {
                      setConsultingInfo({
                        ...consultingInfo,
                        content: contents,
                      });
                    }}
                    editorHeight={262}
                    style={{
                      width: "964px",
                      marginTop: 6,
                    }}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                  />
                </StyledQuillContainer>
              </DetailPageFormCol>
            </div>
          </DetailPage>
          <DetailPage>
            <DetailPageTitle>강사 소개</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>강사 사진*</DetailFormTitle>
                {consultingInfo.instructorServerFileName ||
                consultingInfo.fileUrlInstructor ? (
                  <ImgPreview
                    fileUrl={
                      consultingInfo.fileUrlInstructor
                        ? consultingInfo.fileUrlInstructor
                        : imgUrl + consultingInfo.instructorServerFileName
                    }
                    onClick={() => {
                      delImg("instructor");
                    }}
                  />
                ) : (
                  <ImgInput
                    id={"instructor"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e, "instructor");
                    }}
                  />
                )}
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강사명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"강사명을 입력해주세요"}
                  value={consultingInfo.instructorName}
                  onChange={(e) =>
                    setConsultingInfo({
                      ...consultingInfo,
                      instructorName: e.target.value,
                    })
                  }
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>소개글*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "744px",
                  }}
                  type={"text"}
                  placeholder={"소개글을 입력해주세요"}
                  value={consultingInfo.instructorIntro}
                  onChange={(e) =>
                    setConsultingInfo({
                      ...consultingInfo,
                      instructorIntro: e.target.value,
                    })
                  }
                />
              </DetailPageForm>

              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>경력사항*</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <MainInput
                      style={{
                        width: "338px",
                      }}
                      type={"text"}
                      placeholder={"경력사항을 입력해 주세요."}
                      value={career}
                      onChange={(e) => setCareer(e.target.value)}
                    />
                    <CareerBtn
                      onClick={() => {
                        if (!career.trim()) {
                          return toast("경력사항을 입력해 주세요.");
                        }
                        setConsultingInfo({
                          ...consultingInfo,
                          career: [...consultingInfo.career, career.trim()],
                        });
                        setCareer("");
                      }}
                    >
                      <PretendardText
                        style={{
                          color: "#636C73",
                          fontWeight: 600,
                          fontSize: "15px",
                        }}
                      >
                        + 추가
                      </PretendardText>
                    </CareerBtn>
                  </div>

                  {consultingInfo.career.length > 0 ? (
                    <>
                      {consultingInfo.career.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              gap: "10px",
                            }}
                          >
                            <MainInput
                              style={{
                                width: "338px",
                              }}
                              type={"text"}
                              placeholder={"경력사항을 입력해 주세요."}
                              value={item}
                              onChange={(e) =>
                                changeCareer(e.target.value, index)
                              }
                            />
                            <CareerBtn
                              onClick={() => {
                                const copyArr = [...consultingInfo.career];
                                copyArr.splice(index, 1);
                                setConsultingInfo({
                                  ...consultingInfo,
                                  career: copyArr,
                                });
                              }}
                            >
                              <PretendardText
                                style={{
                                  color: "#636C73",
                                  fontWeight: 600,
                                  fontSize: "15px",
                                }}
                              >
                                - 삭제
                              </PretendardText>
                            </CareerBtn>
                          </div>
                        );
                      })}
                    </>
                  ) : null}
                </div>
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler();
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
};

export default ConsultingEdit;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const StyledQuillContainer = styled.div`
  //.ql-editor {
  //    padding: 0;
  // }
`;

const CareerBtn = styled.div`
  height: 48px;
  border: 1px solid #dfe1e4;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  cursor: pointer;
`;
